angular.module('core')
    .component('periodFormatter', {
        bindings: {
            start: '<',
            end: '<',
            format: '@?',
            showUnlimited: '<?'
        },
        template: `
            <div ng-if="$ctrl.start != null || $ctrl.end != null">
                <span class="small" ng-if="$ctrl.start != null && $ctrl.end == null">od</span>
                <span class="small" ng-if="$ctrl.start == null && $ctrl.end != null">do</span>
                <span ng-if="$ctrl.start != null && $ctrl.format == null">{{$ctrl.start}}</span>
                <span ng-if="$ctrl.start != null && $ctrl.format != null">{{$ctrl.start | date: $ctrl.format}}</span>
                <span ng-if="$ctrl.start != null && $ctrl.end != null">&nbsp;-&nbsp;</span>
                <span ng-if="$ctrl.end != null && $ctrl.format == null">{{$ctrl.end}}</span>
                <span ng-if="$ctrl.end != null && $ctrl.format != null">{{$ctrl.end | date: $ctrl.format}}</span>
                <span class="italic" ng-if="$ctrl.showUnlimited == true && $ctrl.end == null">(bezterminowo)</span>
            </div>
        `
    })
